import React from 'react';
import { oysterTheme } from '@yaydoo/react-components/lib/theme';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import IconButton from '@material-ui/core/IconButton';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import Input from '@components/common/Input';

import useStyles from './select.styles';
import { MenuItem } from '@material-ui/core';

export interface SelectOptionProps {
  value: string;
  label: string;
  name: string;
}

const ArrowDown: React.FC<any> = ({ className, value, handleDeleteSelection, ...rest }) => {
  if (value === '') {
    return (
      <KeyboardArrowDownIcon
        {...rest}
        className={className}
        style={{
          color: oysterTheme.oyster,
        }}
      />
    );
  }

  return (
    <IconButton {...rest} onClick={handleDeleteSelection} aria-label="delete">
      <CancelRoundedIcon fontSize={'small'} style={{ color: oysterTheme.ferrari }} />
    </IconButton>
  );
};

export const SelectInput: React.FC<any> = ({
  options,
  valueKey,
  labelKey,
  value,
  handleDeleteSelection,
  ...restProps
}) => {
  const css = useStyles();

  return (
    <Input
      {...restProps}
      value={value}
      select
      SelectProps={{
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        },
        IconComponent: (props) => ArrowDown({ ...props, value, handleDeleteSelection }),
        classes: {
          root: css.root,
          select: css.select,
        },
      }}
    >
      {options?.map((opt: typeof options[0]) => (
        <MenuItem key={opt[valueKey]} value={opt[valueKey]} className={css.item}>
          {opt[labelKey]}
        </MenuItem>
      ))}
    </Input>
  );
};

export default SelectInput;
